export const DEFAULT_ENHANCEMENT_MODEL = 'google/gemini-2.5-flash';
